import { IToken } from '../types';

export const defaultToken: IToken = {
  tokenType: null,
  expiresIn: 0,
  redirectUri: null,
  accessToken: null,
  idToken: null,
  refreshToken: null,
};
